<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="14"> </caass-schoolselector>
						</div>
					</div>

					<!--StartDate-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Start Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.StartDate" name="txtStartDate"></p-calendar>
						</div>
					</div>

					<!--EndDate-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">End Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.EndDate" name="txtEndDate"></p-calendar>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
